import ReactGA from "react-ga4";

export function sendEventToGA(params: any) {
  const { category, action } = params;
  ReactGA.event({
    category,
    action,
  });
}
